import { trackTermsOfUse } from 'actions/tracker/tracker';
import { Accept } from 'components/Accept/Accept';
import { useFlysiteUrls } from 'hooks/useFlysiteUrls';
import type React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect, useSelector } from 'react-redux';
import { getCurrentLocale } from 'selectors/ui/ui';
import { useTranslations } from 'utils/translations/useTranslations';

type TermsAndConditionProps = ConnectedProps<typeof connector> & {
  checked?: boolean;
  error?: string | boolean;
  name: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
};

function TermsAndConditionsComponent({
  checked,
  error,
  name,
  onChange,
  required,
  trackTermsOfUse,
}: TermsAndConditionProps) {
  const i18n = useTranslations();
  const locale = useSelector(getCurrentLocale);
  const { privacyUrl, termsUrl } = useFlysiteUrls(locale);

  const termsOfUseLink = (
    <a
      className="Link"
      href={termsUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="termsOfUseLink"
      onClick={() => trackTermsOfUse('terms of use')}
    >
      {i18n.t('termsAndConditions.terms_of_use')}
    </a>
  );

  const privacyPolicyLink = (
    <a
      className="Link"
      href={privacyUrl}
      target="_blank"
      data-testid="privacyPolicyLink"
      rel="noopener noreferrer"
      onClick={() => trackTermsOfUse('privacy policy')}
    >
      {i18n.t('termsAndConditions.privacy_policy')}
    </a>
  );

  return (
    <Accept
      checked={checked}
      error={error && i18n.t('termsAndConditions.error')}
      onChange={onChange}
      name={name}
      required={required}
    >
      {i18n.t('termsAndConditions.terms_read')} {termsOfUseLink}{' '}
      {i18n.t('termsAndConditions.and')} {privacyPolicyLink}
    </Accept>
  );
}

const mapDispatchToProps = {
  trackTermsOfUse,
};

const connector = connect(null, mapDispatchToProps);

const TermsAndConditions = connector(TermsAndConditionsComponent);

export { TermsAndConditions };
